/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_D4tInputs */

const en_mk_sol_agensi_d4t = /** @type {(inputs: Mk_Sol_Agensi_D4tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before it ships: the approval is on the record`)
};

const id_mk_sol_agensi_d4t = /** @type {(inputs: Mk_Sol_Agensi_D4tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum tayang: persetujuan tercatat`)
};

/**
* | output |
* | --- |
* | "Before it ships: the approval is on the record" |
*
* @param {Mk_Sol_Agensi_D4tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_d4t = /** @type {((inputs?: Mk_Sol_Agensi_D4tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_D4tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_d4t(inputs)
	return en_mk_sol_agensi_d4t(inputs)
});